import React, { FC, useContext } from 'react';
import styled, { css } from 'styled-components';
import { UiStateContext } from '../../context/UiStateContext';
import { Panel } from '../Panel';
import Spacer from '../Spacer';
import { TickList } from '../TickList';
import { Typography } from '../Typography';

export interface RegisterCallToActionProps {}

export const RegisterCallToAction: FC<RegisterCallToActionProps> = ({ ...rest }) => {
  const { setActiveBlade } = useContext(UiStateContext);
  return (
    <Panel
      heading="Need an account?"
      border
      buttonOne={{
        label: 'Register for MyKFH',
        variant: 'outline',
        type: 'button',
        onClick: () => setActiveBlade('register'),
        eventClickBladeId: 'register',
      }}
      {...rest}
    >
      <Spacer spacing="half">
        <Typography variant="lead">Make finding your perfect property easier with a MyKFH account.</Typography>
        <TickList
          items={[
            { text: 'Create and save custom property alerts' },
            { text: 'Save your search criteria for next time' },
            { text: 'Shortlist your favourite properties' },
          ]}
        />
      </Spacer>
    </Panel>
  );
};
